import { withStyles } from '@material-ui/core';
import FsBody from 'ui-elements/typography/FsBody';

export const Question = withStyles(({ spacing }) => ({
  root: {
    marginBottom: spacing(1),
  },
}))(FsBody);
